module.exports = __webpack_public_path__ + "img/pic_tic@2x.19171bf7.png";